import React, { createContext, useContext, useState, useCallback } from 'react';

const ErrorContext = createContext();

export const useError = () => {
    const context = useContext(ErrorContext);
    if (!context) {
        throw new Error('useError must be used within an ErrorProvider');
    }
    return context;
};

export const ErrorProvider = ({ children }) => {
    const [errors, setErrors] = useState([]);
    const [isOpen, setIsOpen] = useState(false);

    const addError = useCallback((message) => {
        const newError = {
            id: Date.now() + Math.random(), // Simple unique ID
            message,
            timestamp: new Date().toLocaleTimeString()
        };
        setErrors(prev => [...prev, newError]);
        setIsOpen(true); // Auto-open on error, or we can make this optional
    }, []);

    const removeError = useCallback((id) => {
        setErrors(prev => prev.filter(err => err.id !== id));
    }, []);

    const clearErrors = useCallback(() => {
        setErrors([]);
    }, []);

    const toggleSidebar = useCallback(() => {
        setIsOpen(prev => !prev);
    }, []);

    return (
        <ErrorContext.Provider value={{
            errors,
            addError,
            removeError,
            clearErrors,
            isOpen,
            toggleSidebar,
            setIsOpen
        }}>
            {children}
        </ErrorContext.Provider>
    );
};
